import { requestMultipart, requestWithPromise } from '..'
import { DELETE, GET, PATCH, POST, makeQueryString } from '../apiHelper'

export const createInternshipRequest = (user, internshipRequest) => {
  return requestWithPromise(
    '/api/individual-internship-requests',
    POST,
    internshipRequest.toRequestBody(),
    user
  )
}

export const getAllInternshipRequests = (user, parameters = {}) => {
  return requestWithPromise(
    `/api/individual-internship-requests${makeQueryString(parameters)}`,
    GET,
    null,
    user
  )
}

export const deleteInternshipRequest = (user, internshipRequest) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}`,
    DELETE,
    null,
    user
  )
}

export const updateInternshipRequest = (user, internshipRequest) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}`,
    PATCH,
    internshipRequest.toRequestBody(),
    user
  )
}

export const setInternshipRequestToOnHold = (user, internshipRequest) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}/on-hold`,
    PATCH,
    {},
    user
  )
}

export const getInternshipRequestFiles = (user, internshipRequest) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}/files`,
    GET,
    null,
    user
  )
}

export const deleteInternshipRequestFile = (user, internshipRequest, internshipRequestFile) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}/files/${internshipRequestFile.id}`,
    DELETE,
    null,
    user
  )
}

export const addInternshipRequestFile = (user, internshipRequest, file) => {
  return requestMultipart(
    `/api/individual-internship-requests/${internshipRequest.id}/files`,
    POST,
    file,
    user
  )
}

export const createInternshipRequestPeriod = (user, internshipRequest, requestPeriod) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}/request-periods`,
    POST,
    requestPeriod,
    user
  )
}

export const deleteInternshipRequestPeriod = (user, internshipRequest, requestPeriod) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}/request-periods/${requestPeriod.id}`,
    DELETE,
    null,
    user
  )
}

export const deleteInternshipRequestPeriods = (user, internshipRequest, parameters = { ids: [] }) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}/request-periods${makeQueryString(parameters)}`,
    DELETE,
    null,
    user
  )
}

export const updateInternshipRequestPeriod = (user, internshipRequest, requestPeriod) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}/request-periods/${requestPeriod.id}`,
    PATCH,
    requestPeriod,
    user
  )
}

export const acceptInternshipRequest = (user, internshipRequest, requestPeriod) => {
  return requestWithPromise(
    '/internship/create-from-request',
    POST,
    { individualInternshipRequest: internshipRequest.id, requestPeriod: requestPeriod.id },
    user
  )
}

export const refuseInternshipRequest = (user, internshipRequest) => {
  return requestWithPromise(
    `/api/individual-internship-requests/${internshipRequest.id}/refuse`,
    DELETE,
    null,
    user
  )
}
